export default function(text: string): string {
  return text ? text.replace(/(?:\r\n|\r|\n)/g, "<br />") : "";
}
